import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/LayoutComponents/Header';
import Footer from './components/LayoutComponents/Footer';
import Home from './pages/HomePage';
import BookPage from './pages/BookPage';
import AppDownload from './pages/AppDownload';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import { UserProvider } from './utility/UserContext';
import { adminRoutes } from "./admin/routes";

function App() {
  return (
    <Router>
      <UserProvider>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/app-download" element={<AppDownload />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/books/:id" element={<BookPage />} />

              {/* Admin Routes */}
              {adminRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element}>
                  {route.children?.map((child, childIndex) => (
                    <Route
                      key={`${index}-${childIndex}`}
                      path={child.path}
                      element={child.element}
                    />
                  ))}
                </Route>
              ))}
            </Routes>
          </main>
          <Footer />
        </div>
      </UserProvider>
    </Router>
  );
}

export default App; 